import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { advrechargeGear, advrechargeGear_currency } from "@/api/dataAll/recharge"; //充值档位搜索接口

export default {
  name: "advrechargeGear",
  mixins: [tabulation],
  data: function data() {
    return {
      tableData: [],
      tableLtv: [],
      intReq: ["getCountrys"]
    };
  },
  created: function created() {},
  methods: {
    searchClick: function searchClick() {
      var _this = this;

      // if (this.currencyClose && !this.searchData.currency_info) {
      //   this.$message.error('请选择货币类型')
      //   return
      // }
      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      this.reqLoading = true;
      var reqFn = this.currencyClose ? advrechargeGear_currency : advrechargeGear;
      reqFn(_objectSpread(_objectSpread({}, this.searchData), this.defaultData())).then(function (res) {
        if (res.status == 200) {
          _this.tableData = res.data;

          _this.$nextTick(function () {
            _this.getTableRight();
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('date'),
        prop: "date"
      }, {
        label: this.$t('rechargePeopleNum'),
        prop: "recharge_num"
      }, {
        label: this.$t('firstRechargeCount'),
        prop: "first_num"
      }];
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};